import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import SvgIcon from '@mui/material/SvgIcon';
import SvgAlert from '@digital-hig/icon/lib/esm/display-icons/alert';
import SvgComplete from '@digital-hig/icon/lib/esm/display-icons/complete';
import SvgError from '@digital-hig/icon/lib/esm/display-icons/error';
import SvgInfo from '@digital-hig/icon/lib/esm/display-icons/info';
import { alpha } from '@mui/material/styles';
import {
  BANNER_TYPE_ERROR,
  BANNER_TYPE_INFO,
  BANNER_TYPE_SUCCESS,
  BANNER_TYPE_WARNING,
  styleVariables,
} from '../common/constants';

const Banner = ({
  type, children, className,
}) => {
  let icon = '';
  // Modified for story CREDSYS-7884
  switch (type) {
  case BANNER_TYPE_INFO:
    icon = (
      <SvgIcon
        id="dhig--icons--display-icons--info"
        fontSize="large"
        sx={{
          alignSelf: { sm: 'flex-start', lg: 'center' },
        }}
      >
        <SvgInfo />
      </SvgIcon>
    );
    break;
  case BANNER_TYPE_SUCCESS:
    icon = (
      <SvgIcon
        id="dhig--icons--display-icons--complete"
        size="medium"
      >
        <SvgComplete />
      </SvgIcon>
    );
    break;
  case BANNER_TYPE_WARNING:
    icon = (
      <SvgIcon
        id="dhig--icons--display-icons--alert"
        size="medium"
      >
        <SvgAlert />
      </SvgIcon>
    );
    break;
  case BANNER_TYPE_ERROR:
  default:
    icon = (
      <SvgIcon
        id="dhig--icons--display-icons--error"
        size="medium"
      >
        <SvgError />
      </SvgIcon>
    );
    break;
  }
  const RootElement = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    min-height: 42px;
    
    &.${BANNER_TYPE_INFO} {
      background-color: ${alpha(styleVariables.fillEngage, 0.2)};
      color: ${styleVariables.fillPrimary};
      border: 1px solid ${styleVariables.fillEngage};
      padding: 16px;
      
      a {
        color: ${styleVariables.white} !important;
        &:not(:hover) {
          text-decoration-color:  ${styleVariables.white} !important;
        }
      }
    
      svg {
       color: ${styleVariables.iris};
       stroke: ${styleVariables.white};     
      }
    }
  
    &.${BANNER_TYPE_SUCCESS} {
      background-color: ${styleVariables.greenFill};
      color: ${styleVariables.white};

      a {
        color: ${styleVariables.white} !important;
        &:not(:hover) {
          text-decoration-color:  ${styleVariables.white} !important;
        }
      }
    
      svg {
       color: ${styleVariables.greenFill};
       stroke: ${styleVariables.white};     
      }
    }
  
    &.${BANNER_TYPE_WARNING} {
      background-color: rgba(255, 249, 232, 1);
      border: 1px solid rgba(255, 194, 26, 1);
      color: ${styleVariables.black};

      a {
        color: ${styleVariables.black} !important;
        &:not(:hover) {
          text-decoration-color:  ${styleVariables.black} !important;
        }
      }
    
      svg {
       color: ${styleVariables.gold};
       stroke: ${styleVariables.black};     
      }
    }
  
    &.${BANNER_TYPE_ERROR} {
      background-color: rgba(250, 237, 233, 1);
      border: 1px solid rgba(204, 75, 36, 1);
      color: ${styleVariables.white};

      a {
        color: ${styleVariables.white} !important;
        &:not(:hover) {
          text-decoration-color:  ${styleVariables.white} !important;
        }
      }
    
      svg {
       color: ${styleVariables.error};
       stroke: ${styleVariables.white};     
      }
    }
  
  
    margin: 8px 0px;
    
    > svg {
      width: 20px;
      height: 20px;
      margin: 6px 7px;
    }
    
    > div {
      flex: 1;
      min-height: 32px;
      height: auto;
      font-weight: 700;
      display: flex;
      align-items: center;
      padding: 0 10px 0px 2px;
      font-size: 14px;
      
      > span {
        width: 100%;
      }
    }
 `;

  return (
    <RootElement className={`${type} ${className}`}>
      {icon}
      <div>
        <span>
          { children }
        </span>
      </div>
    </RootElement>
  );
};

Banner.propTypes = {
  type: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.shape({}).isRequired,
};

Banner.defaultProps = {
  className: '',
};

export default Banner;
